import styled from 'styled-components';

const File = styled.div`
    border: 0.063rem solid ${props => props.theme.color};
    width: 100%;
    padding: 0 1.25rem;
    height: 3.125rem;
    line-height: 3.125rem;
    font-size: 1rem;
    box-sizing: border-box;
    margin-bottom: 0.5rem;
    display: flex;
`;

export default File;